"use client";

import { useState } from "react";
import { Card } from "../UI/card";
import { Button } from "../UI/button";
import JiraSidebar from "./JiraSidebar";

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState("Profile");

  const settingsMenu = [
    "Profile",
    "Notifications",
    "Security",
    "Appearance",
    "Integrations",
  ];

  return (
    <div className="flex flex-1 bg-gray-50">
      {/* ================= MAIN DASHBOARD SIDEBAR ================= */}
      {/* ================= MAIN DASHBOARD SIDEBAR ================= */}
      <JiraSidebar activeItem="settings" />

      {/* ================= MAIN CONTENT ================= */}
      <main className="flex-1 p-6">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-semibold">Settings</h1>
          <p className="text-sm text-gray-500">
            Manage your preferences and configurations
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* ================= SETTINGS INNER SIDEBAR ================= */}
          <Card className="lg:col-span-1 p-4">
            {settingsMenu.map((item) => (
              <div
                key={item}
                onClick={() => setActiveTab(item)}
                className={`px-3 py-2 rounded-md text-sm cursor-pointer mb-1 ${activeTab === item
                  ? "bg-green-100 text-green-700 font-medium"
                  : "text-gray-600 hover:bg-gray-100"
                  }`}
              >
                {item}
              </div>
            ))}
          </Card>

          {/* ================= SETTINGS CONTENT ================= */}
          <Card className="lg:col-span-3 p-6">
            {activeTab === "Profile" && <ProfileTab />}
            {activeTab !== "Profile" && (
              <div className="text-sm text-gray-500">
                {activeTab} settings coming soon...
              </div>
            )}
          </Card>
        </div>
      </main>
    </div>
  );
}

/* ================= SUB COMPONENTS (SAME FILE) ================= */



function ProfileTab() {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold">Profile Settings</h2>

      <div className="flex items-center gap-4">
        <div className="w-14 h-14 rounded-full bg-green-600 text-white flex items-center justify-center text-xl font-bold">
          A
        </div>
        <Button>Change Avatar</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input label="Full Name" defaultValue="Administrator" />
        <Input label="Email" defaultValue="admin@infotech.in" />
        <Input label="Phone" defaultValue="+91 99999 99999" />
        <Textarea label="Bio" />
      </div>

      <div className="flex justify-end gap-3">
        <Button>Cancel</Button>
        <Button className="bg-green-600 hover:bg-green-700">
          Save Changes
        </Button>
      </div>
    </div>
  );
}

function Input({
  label,
  defaultValue,
}: {
  label: string;
  defaultValue?: string;
}) {
  return (
    <div>
      <label className="text-sm font-medium">{label}</label>
      <input
        defaultValue={defaultValue}
        className="w-full mt-1 border rounded-md px-3 py-2 text-sm"
      />
    </div>
  );
}

function Textarea({ label }: { label: string }) {
  return (
    <div className="md:col-span-2">
      <label className="text-sm font-medium">{label}</label>
      <textarea
        rows={3}
        className="w-full mt-1 border rounded-md px-3 py-2 text-sm"
        placeholder="Tell us about yourself"
      />
    </div>
  );
}